<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    v-if="
      $store.getters['checkUserAccess']({
        id: '32',
        action: 'view',
      })
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("history_log") }}
      </h1>
    </div>

    <!-- History Log Table Section -->
    <div class="px-6 py-4">
      <div class="relative overflow-x-auto mt-4 mb-6">
        <div class="flex items-center justify-between pb-4 mx-5">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.history_log.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            />
          </div>
        </div>
        <EasyDataTable
          v-model:server-options="serverOptions"
          :headers="headers"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :rows-items="[25, 50, 100, serverItemsLength]"
          :table-class-name="isDark ? 'modern-dark-table mx-6' : 'mx-6'"
        >
          <template #default="{ column, sortDirection }">
            <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
              </span>
            </div>
          </template>

          <template #item-id="item">
            {{ $t(item.users.name) }}
          </template>

          <template #loading>
            <div class="flex items-center justify-center py-8">
              <img
                src="../../assets/loading.webp"
                class="w-16 h-16 animate-pulse"
                alt="Loading..."
              />
            </div>
          </template>
          <template #item-hl_action="item">
            <span
              :class="getActionBadgeClasses(item.hl_action)"
            >
              {{ $t(item.hl_action) }}
            </span>
          </template>
          <template #item-hl_table="item">
            {{ $t(item.hl_table) }}
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }} </template
          >
          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12 text-gray-500 dark:text-gray-400">
              <i class="fa-solid fa-inbox text-4xl mb-4"></i>
              <span class="text-lg font-medium">{{ $t("no_data_found") }}</span>
            </div>
          </template>
          <template
            #pagination="{
              prevPage,
              nextPage,
              isFirstPage,
              isLastPage,
              currentPaginationNumber,
              maxPaginationNumber,
            }"
          >
            <button :disabled="isFirstPage" @click="goToPage(1)">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-right'
                    : ' fa-angle-double-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              v-for="page in getVisiblePages(
                currentPaginationNumber,
                maxPaginationNumber
              )"
              :key="page"
              @click="goToPage(page)"
              :class="getPageButtonClasses(page, currentPaginationNumber)"
            >
              {{ page }}
            </button>

            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              :disabled="isLastPage"
              @click="goToPage(maxPaginationNumber)"
            >
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-left'
                    : ' fa-angle-double-right')
                "
              ></i>
            </button> </template
        ></EasyDataTable>
      </div>
    </div>
  </div>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import { formatDate } from "../../utils/functions";
import jsPDF from "jspdf";
import "../../assets/font/Rabar_021-normal";
import { applyPlugin } from "jspdf-autotable";
import "../../assets/css/modern-table.css";

applyPlugin(jsPDF);
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],

      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      items: [],
    };
  },
  mounted() {
    // First load when the component is mounted
    if (
      this.$store.getters["checkUserAccess"]({
        id: "37",
        action: "view",
      })
    ) {
      this.loadFromServer();
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.history_log.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.history_log.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("history_log/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.history_log.isShowResultDialog;
    },

    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.history_log.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.history_log.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.history_log.isBtnEditLoading;
    },
    headers() {
      return [
        { text: "#", value: "hl_id", sortable: true },
        { text: this.$t("activity"), value: "hl_action", sortable: true },
        {
          text: this.$t("table"),
          value: "hl_table",
          sortable: true,
        },
        { text: this.$t("id_activity"), value: "hl_action_id", sortable: true },
        { text: this.$t("note"), value: "hl_note", sortable: true },
        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
      ];
    },
  },

  methods: {
    getActionBadgeClasses(action) {
      const normalized = (action || '').toString().toLowerCase();
      // Map common action names to colors
      if (normalized.includes('delete') || normalized.includes('remove')) {
        return 'inline-flex items-center px-2 py-1 text-xs font-medium rounded-md bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300';
      }
      if (normalized.includes('edit') || normalized.includes('update')) {
        return 'inline-flex items-center px-2 py-1 text-xs font-medium rounded-md bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300';
      }
      if (normalized.includes('add') || normalized.includes('create') || normalized.includes('insert')) {
        return 'inline-flex items-center px-2 py-1 text-xs font-medium rounded-md bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300';
      }
      if (normalized.includes('login') || normalized.includes('auth')) {
        return 'inline-flex items-center px-2 py-1 text-xs font-medium rounded-md bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300';
      }
      // default neutral
      return 'inline-flex items-center px-2 py-1 text-xs font-medium rounded-md bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300';
    },
    handleSearchInput(value) {
      this.$store.commit('history_log/SET_SEARCH', value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.history_log.search;

      const res = await this.$store.dispatch("history_log/getItems", tempObj);

      this.items = res.data.data;
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },

    formatDate(date) {
      return formatDate(date);
    },
  },
};
</script>
